import { invalidateReusableBridgePolicyPrefetch } from '@/bridge/prefetchReusableBridgePolicyCoalesced'
import { resetBookableProviderEligibilityPrefetch } from '@/bridge/composables/useBookableProviderEligibilityCalendar'
import { resetFollowupBookingContextPrefetch } from '@/components/consultation/prefetchFollowupBookingContextCoalesced'
import { resetPrewarmClinicalBookingClientDataCoalesce } from '@/components/consultation/prewarmClinicalBookingClientData'
import { resetConsultationUxStackPrewarmCoalesce } from '@/components/consultation/useConsultationUxStackPrewarm'

/** Clears module-level booking client prefetch/coalesce state (no I/O). */
export function resetClinicalBookingClientCaches(): void {
  resetFollowupBookingContextPrefetch()
  invalidateReusableBridgePolicyPrefetch()
  resetBookableProviderEligibilityPrefetch()
  resetConsultationUxStackPrewarmCoalesce()
  resetPrewarmClinicalBookingClientDataCoalesce()
}
